import React, { PureComponent } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';

import { Breadcrumb, Input } from '../../common/components';
import { getBreakdownType, saveBreakdownType } from '../services/dictionary.service';

class DictBreakdownTypeForm extends PureComponent {
  state = {
    name: '',
  };

  async componentDidMount() {
    const { match: { params } } = this.props;

    if (params.id) {
      const breakdownType = await getBreakdownType(params.id);

      this.setState({
        ...breakdownType,
      });
    }
  }

  onInputChange = (name, value) => this.setState({ [name]: value });

  handleAddModel = async () => {
    try {
      const { history } = this.props;

      await saveBreakdownType({ ...this.state });

      history.replace(history.goBack());
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const { name } = this.state;

    const { match: { params } } = this.props;
    const title = params.id ? 'Edycja grupy' : 'Dodawanie nowej grupy';

    return (
      <>
        <Breadcrumb title={title} />
        <div className="content">
          <div className="card">
            <div className="card-header">Nazwa grupy</div>
            <div className="d-flex align-items-center mb-4">
              <div className="form-inline w-100 d-flex justify-content-between p-4">
                <Input
                  id="name"
                  placeholder="Nazwa grupy awarii"
                  value={name}
                  onChange={this.onInputChange}
                />

                <div className="form-group float-right">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={this.handleAddModel}
                  >
                    Zapisz zmiany
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

DictBreakdownTypeForm.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withRouter(DictBreakdownTypeForm);
